import WellDone from './images/undraw_well_done_re_3hpo.svg'
import Cancel from './images/undraw_cancel_re_pkdm.svg'
import ForgotPassword from './images/undraw_forgot_password_re_hxwm.svg'

export const ImageAsset = {
    WellDone: WellDone,
    Cancel: Cancel,
    ForgotPassword: ForgotPassword
}